import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Button } from './ui/Button';
export function OfferSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section id="offer-section" className="py-24 px-4 bg-teal text-center relative overflow-hidden" data-id="element-105">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-106">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold rounded-full blur-[100px]" data-id="element-107"></div>
      </div>

      <div ref={ref} className={`max-w-3xl mx-auto relative z-10 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-108">
        <h2 className="text-3xl md:text-5xl font-serif text-cream mb-6" data-id="element-109">
          Detén el ciclo de agotamiento hoy mismo.
        </h2>
        <p className="text-xl text-sage mb-12" data-id="element-110">
          No esperes a que tu cuerpo te obligue a parar con una enfermedad o un
          colapso total.
        </p>

        <div className="bg-cream p-8 md:p-12 rounded-3xl shadow-2xl max-w-xl mx-auto transform hover:scale-[1.02] transition-transform duration-500" data-id="element-111">
          <div className="text-teal font-serif text-2xl mb-2" data-id="element-112">
            Pago único de
          </div>

          <div className="inline-block bg-gold text-teal font-bold text-sm px-4 py-1.5 rounded-full mb-4 tracking-wide uppercase" data-id="element-113">
            65% OFF
          </div>

          <div className="text-xl text-charcoal/40 line-through mb-1" data-id="element-114">
            $19.99 USD
          </div>

          <div className="text-6xl md:text-7xl font-bold text-teal mb-6 flex items-start justify-center" data-id="element-115">
            6.99
          </div>

          <p className="text-charcoal mb-8" data-id="element-116">
            Es menos de lo que cuesta una cena fuera, pero con beneficios que
            durarán toda la vida.
          </p>

          <Button href="https://www.digilecto.com/cart/51078003097878:1" className="w-full text-lg md:text-xl py-5" subtext="Acceso inmediato y de por vida" data-id="element-117">
            DESCARGAR ESTE REINICIO AHORA
          </Button>

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-charcoal/60" data-id="element-118">
            <svg className="w-4 h-4 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-119">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-120" />
            </svg>
            Pago 100% seguro y encriptado
          </div>
        </div>
      </div>
    </section>;
}